module.exports = __webpack_public_path__ + "static/media/rhodium.b74c0a7a.jpg";